import Helper from "../Helper";
import BaseModal from "./BaseModal";

/**
 * This class represents responsive draggable modals.
 */
export default class ResponsiveModal extends BaseModal {
	/**
	 *
	 * @param {String} modalName
	 * @param {Function} afterHideCallback called after modal is fully hidden
	 * @param {Function} dragCallback called every drag step
	 */
	constructor(modalName, afterHideCallback, dragCallback) {
		super();
		this.$modal = $('[data-respo-modal="' + modalName + '"]');
		this.$dim = $('[data-dim="respo-' + modalName + '"]');
		this.isOpened = false;
		this.afterHideCallback = afterHideCallback;
		this.dragCallback = dragCallback;
		this.completeCallback = undefined;

		this.heightOffset = 56;
		this.initHeight = window.innerHeight - this.heightOffset;
		this.height = this.initHeight;
		this.dragOffsetY = undefined; // y pos inside modal, if set, drag is active
		this.dragCallbackInterval = undefined;
		this.isReseting = false;

		this.initModal();
	}

	/**
	 * This function initialize the modal.
	 */
	initModal() {
		/**
		 * On window resize update init height
		 */
		window.windowResizeObserve.register(() => {
			this.initHeight = window.innerHeight - this.heightOffset;
			this.reset();
		});

		this.$dim.click(() => {
			if (this.$dim.hasClass("active")) {
				this.hide();
			}
		});

		/**
		 * Dragging logic
		 */
		this.$modal.on("touchstart", (event) => {
			try {
				let touch = event.touches[0] || event.changedTouches[0];
				let y = touch.clientY;
				let modalTopPos = this.getTopPosition();

				if (y >= modalTopPos - 10 && y <= modalTopPos + 98) {
					// y is in upper rectangle
					this.dragOffsetY = y - modalTopPos;
					this.$modal.css("transition", "unset");
				}
			} catch (err) {}
		});

		this.$modal.on("touchend", () => {
			this.dragOffsetY = undefined;
			this.$modal.css("transition", "");

			// If dragging ended under 75% of modal height close it, else animate it to full height again
			if (this.height <= this.initHeight - this.initHeight / 4) {
				this.$modal.css("transform", "");
				this.hide();
			} else {
				this.reset();
			}
		});
		$(document).on("touchmove", (event) => {
			try {
				let touch = event.touches[0] || event.changedTouches[0];
				let y = touch.clientY;

				// If is touching drag rectangle and is not already dragged to its height limit
				if (this.dragOffsetY && y - this.dragOffsetY >= this.heightOffset) {
					if (Helper.isMobileOS()) event.preventDefault();

					let newY = parseInt(y - this.dragOffsetY);
					this.height = window.innerHeight - y + this.dragOffsetY;
					this.$modal.css("transform", "translateY(" + newY + "px)");

					this.dragCallback(this.height);
				}
			} catch (err) {}
		});

		// On animation start
		this.$modal.on("transitionstart", () => {
			// When is from opened to closed
			if (!this.isOpened) {
				this.dragCallbackInterval = this.startDragCallbackInterval();
			} else if (this.isReseting) {
				this.dragCallbackInterval = this.startDragCallbackInterval();
			}
		});

		// On animation end
		this.$modal.on("transitionend", () => {
			// If modal was opened
			if (this.isOpened) {
				if (this.completeCallback) {
					// After modal was opened
					this.completeCallback();
					this.completeCallback = undefined;

					this.height = this.initHeight;
				} else {
					// After modal was reseted
					this.clearDragCallbackInterval();
					this.dragCallback();
					this.isReseting = false;
				}
			} else {
				// After modal was hidden
				this.$modal.css("transform", "");
				this.clearDragCallbackInterval();
				this.afterHideCallback();
			}
		});
	}

	/**
	 * Opens the modal.
	 *
	 * @param {Function} beforeCallback calls before opening
	 * @param {Function} completeCallback calls when opening is complete
	 */
	open(beforeCallback, completeCallback) {
		if ($(window).width() <= window.bigMobileBreakpoint && !this.isOpened) {
			beforeCallback();

			this.completeCallback = completeCallback;

			this.$modal.addClass("active");
			this.$dim.addClass("active");
			this.isOpened = true;

			$("body").css("position", "fixed");

			if (Helper.isIOS()) {
				$("#content").css("height", window.innerHeight + "px");
			}
		}
	}

	/**
	 * Will reset opened modal.
	 */
	reset() {
		this.isReseting = true;
		this.height = this.initHeight;
		this.$modal.css("transform", "");
	}

	/**
	 * Hides the modal.
	 */
	hide() {
		this.$dim.removeClass("active");

		this.$modal.removeClass("active");
		this.isOpened = false;

		$("body").css("position", "relative");
		if (Helper.isIOS()) $("#content").css("height", "");
	}

	/**
	 * Checks if the respo search modal is opened.
	 *
	 * @returns {boolean}
	 */
	isModalOpened() {
		return this.isOpened;
	}

	/**
	 * Checks if the respo modal is being dragged right now.
	 *
	 * @returns {Boolean}
	 */
	isBeingDragged() {
		return typeof this.dragOffsetY !== "undefined";
	}

	/**
	 * Top position of modal relative to screen
	 *
	 * @returns {Number}
	 */
	getTopPosition() {
		return this.$modal.offset().top - $(window).scrollTop();
	}

	/**
	 * Keep actions content inside respo modal till its closed or reset
	 *
	 * @returns {Number}
	 */
	startDragCallbackInterval() {
		return setInterval(() => {
			this.dragCallback();
		}, 1);
	}

	/**
	 * Will keep th drag callback interval.
	 */
	clearDragCallbackInterval() {
		clearInterval(this.dragCallbackInterval);
		this.dragCallbackInterval = undefined;
	}
}
